module.exports = __webpack_public_path__ + "static/media/CandidacyUpload_Template.49a0b459.xlsx";